import axios from "axios";
import { CommonConstant } from "../constants/common.constant";
import { DisplayLoader } from "../data/loader/loaderAction";
import { History } from "../utils/customUtils";
import { api, ENABLE_API_CACHE, LOCAL_DATABASE } from './db';
let callStack = [];

export const get = (urlEndpoint, data, dispatch, optionalFunc, NoLoader = false, exactEndpoint = false) => {
  return callAPI({ type: "get", urlEndpoint, data, dispatch, optionalFunc, NoLoader, exactEndpoint });
};

export const put = (urlEndpoint, data, dispatch, optionalFunc, NoLoader = false, exactEndpoint = false) => {
  return callAPI({ type: "put", urlEndpoint, data, dispatch, optionalFunc, NoLoader, exactEndpoint });
};

export const post = (urlEndpoint, data, dispatch, optionalFunc, NoLoader = false, exactEndpoint = false) => {
  return callAPI({ type: "post", urlEndpoint, data, dispatch, optionalFunc, NoLoader, exactEndpoint });
};

export const _delete = (urlEndpoint, data, dispatch, optionalFunc, NoLoader = false, exactEndpoint = false) => {
  return callAPI({ type: "delete", urlEndpoint, data, dispatch, optionalFunc, NoLoader, exactEndpoint });
};

const stopLoader = (callStack, dispatch) => {
  if (callStack && callStack.length === 0 && dispatch) {
    dispatch(DisplayLoader(false));
  }
};

const loaderPop = (callStack, url) => {
  let removeIndex = -1;
  for (let i = 0; i < callStack.length; i++) {
    if (url.endsWith(callStack[i])) {
      removeIndex = i;
      break;
    }
  }
  if (removeIndex !== -1) {
    callStack.splice(removeIndex, 1);
  }
  return callStack;
};

const callAPI = async ({
  type,
  urlEndpoint,
  data = {},
  dispatch,
  optionalFunc,
  NoLoader,
  exactEndpoint = false,
}) => {
  const authObj =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"));

  let url = '';
  if (exactEndpoint) {
    url = urlEndpoint;
  }

  if (!exactEndpoint) {
    url = CommonConstant.BASE_URL + urlEndpoint;
  }

  if (!exactEndpoint && urlEndpoint === "api/v1/Authentication") {
    url = CommonConstant.LOGIN_URL + urlEndpoint;
  }

  if (!exactEndpoint && urlEndpoint === "searchOrders") {
    url = CommonConstant.SEARCH_ORDERS + data.req;
    urlEndpoint = url;
  }
  
  if (!exactEndpoint && urlEndpoint === "authserver/api/Authentication/LogOFF") {
    url = CommonConstant.BASE_URL.split("api/")[0] + urlEndpoint;
  }

  const axiosConfig = {
    method: type,
    url,
    ...data,
  };
  if (authObj && authObj.Token && axiosConfig && !axiosConfig.headers) {
    axiosConfig["headers"] = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authObj.Token,
    };
  }

  if (callStack && callStack.length === 0 && dispatch && !NoLoader) {
    dispatch(DisplayLoader(true));
  }
  if (!NoLoader) {
    callStack.push(urlEndpoint);
  }

  // if (type !== 'GET') {
  //     axiosConfig.data = data;
  // }

  const isCacheEnabled = ENABLE_API_CACHE && LOCAL_DATABASE && axiosConfig.method === 'get';
  /**
   * @description fetch the cached api response
   */
  if (isCacheEnabled) {
    try {
      const cache = await api.get(axiosConfig.url);
      if (cache && !cache.error && cache.response) {
        if (!NoLoader) {
          callStack = loaderPop(callStack, axiosConfig.url);
          stopLoader(callStack, dispatch);
        }
        return cache.response;
      }
    } catch(e) {
    }
  }

  return axios(axiosConfig)
    .then(async (res) => {
      /**
       * @description cache the api response
       */
      if (isCacheEnabled) {
        try {
          await api.putOrUpdate({_id: axiosConfig.url, response: { data: res.data }});
        } catch (e) {
        }
      }

      if (!NoLoader) {
        callStack = loaderPop(callStack, axiosConfig.url);
        stopLoader(callStack, dispatch);
      }
      if (
        axiosConfig.url ===
        CommonConstant.LOGIN_URL + "authserver/api/Authentication/ValidateToken"
      ) {
        res.data.callStack = [...callStack];
        return res;
      }
      if (optionalFunc) {
        return optionalFunc(dispatch);
      } else {
        return res;
      }
    })
    .catch((err) => {
      if (!NoLoader) {
        callStack = loaderPop(callStack, axiosConfig.url);
        stopLoader(callStack, dispatch);
      }

      if (
        History.location.pathname !== "/" &&
        err.response &&
        (err.response.status === 403 || err.response.status === 401)
      ) {
        localStorage.removeItem("userData");
        localStorage.removeItem("userId");
        if (NoLoader) {
          return Promise.reject(err);
        }
        window.location.href = process.env.REACT_APP_LOGOUT_URL;
      }

      return Promise.reject(err);
    });
};
